import { render, staticRenderFns } from "./CommentType.vue?vue&type=template&id=0247c9b8"
import script from "./CommentType.vue?vue&type=script&lang=js"
export * from "./CommentType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports